import React from 'react';
import { Fragment } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { HelpCenterContext } from './Context/HelpCenterContext';
import { VideoArticleBlocks } from './VideoArticleBlocks';

export const SearchResults = () => {
    const { state, dispatch } = useContext(HelpCenterContext)
    const [slicevalue, setSlicevalue] = useState(3)

    const getData = () => {
        const videoResult = state.searchResult.filter(item => item.tag === "Video").slice(0, slicevalue)
        const articleResult = state.searchResult.filter(item => item.tag === "Article").slice(0, slicevalue)
        const results = articleResult.length + videoResult.length
        return {
            articleResult,
            videoResult,
            results
        }
    }
    return (
        <Fragment>
            {state.searchKeyword !== "" &&
                <div className="mt-2">
                    {state.searchResult.length > 0 ?
                        <Fragment>
                            <strong>Search Results <span className="text-secondary">({state.searchResult.length})</span></strong>
                            <div className='mt-3'>
                                {getData().articleResult.map(item => (
                                    <div className="mb-3" onClick={() => dispatch({ type: "TOGGLE_DETAIL_COMPONENT", payload: item })}>
                                        <strong className="topic-links">{item.text}</strong>
                                        <small className="card-text text-muted d-block">{item.keyword} - <span>{item.tag}</span></small>
                                    </div>
                                ))}
                                <VideoArticleBlocks data={getData().videoResult} />
                            </div>
                        </Fragment>
                        :
                        <Fragment>
                            <strong>Search Results <span className="text-secondary">({state.searchResult.length})</span></strong>
                            <p className="my-3">No results found for {state.searchKeyword}</p>
                        </Fragment>
                    }
                    {(state.searchResult.length > 5 && state.searchResult.length !== (state.searchResult.slice(0, slicevalue).length)) &&
                        <p type={"button"} onClick={() => setSlicevalue(slicevalue + 3)} className="text-primary mt-3">See more search results...</p>
                    }
                </div>
            }
        </Fragment>
    )
}